import consumer from "./consumer"

export function subscribeCsClientActivity(id: string, callback: () => void) {
  return consumer.subscriptions.create(
    { channel: "CsClientActivityChannel", id: id },
    {
      received() {
        callback()
      }
    }
  )
}
